import { useGetRedirectPath } from 'helpers/getRedirectPath';

import { ILogoProps } from './types';

import * as S from './styled';

const Logo = ({ withoutText, height }: ILogoProps) => {
    const link = useGetRedirectPath();

    return (
        <S.LogoContainer to={link} height={height}>
            <S.LogoImage />
            {!withoutText && <S.LogoText />}
        </S.LogoContainer>
    );
};

export default Logo;
